import React, { useEffect, useRef } from "react";
import Logo from "../assets/ops-banner.png";
import moment from "moment";
import JsBarcode from "jsbarcode";
const Row = ({ label, value }) => (
  <div className="flex gap-2 py-1">
    <span className="font-semibold text-gray-700">{label}</span>
    <span>{value || "-"}</span>
  </div>
);
const Barcode = ({ value }) => {
  const ref = useRef(null);

  useEffect(() => {
    if (value) {
      JsBarcode(ref.current, value, {
        format: "CODE128",
        width: 1,
        height: 40,
        margin: 0,
        padding: 0,
        displayValue: true,
        fontSize: 10,
      });
    }
  }, [value]);

  return <svg ref={ref}></svg>;
};
const ManifestPreview = ({ manifest, printRef }) => {
  return (
    <div ref={printRef} className="p-6 text-sm bg-white text-black w-full">
      {/* Header */}
      <div className="flex justify-between items-center border-b pb-3 mb-4 gap-4">
        <div>
          <img src={Logo} alt="Company Logo" className="h-12 object-contain" />
        </div>
        <div>
          <Barcode value={manifest?.manifestNo} />
          {/* <span className="text-xs mt-1">{manifest?.manifestNo}</span> */}
        </div>
      </div>

      {/* Top Info */}
      <div className="grid grid-cols-1 gap-6 mb-5">
        <div>
          <Row
            label="Manifest Date:"
            // value={manifest?.dispatchDate}
            value={moment(manifest?.dispatchDate).format("DD-MM-YYYY")}
          />
          <Row
            label="Manifest Time:"
            value={moment(manifest?.dispatchTime, "HH:mm:ss").format(
              "hh:mm:ss A",
            )}
          />
          <Row label="Manifest No:" value={manifest?.manifestNo} />
          <Row label="Vehicle No:" value={manifest?.vehicleNo} />
          <Row label="Destination:" value={manifest?.destination} />
        </div>

        {/* <div>
          <Row label="Driver Name" value={manifest?.driverName} />
          <Row label="Loading Master" value={manifest?.loadingMaster} />
        </div> */}
      </div>

      {/* Table */}
      <table className="w-full border border-black border-collapse text-xs">
        <thead>
          <tr className="bg-gray-200">
            {["SL", "LR No", "Boxes", "Weight", "Destination", "Next Hub"].map(
              (h) => (
                <th key={h} className="border border-black px-2 py-1">
                  {h}
                </th>
              ),
            )}
          </tr>
        </thead>

        <tbody>
          {manifest?.shipments?.length > 0 ? (
            <>
              {manifest?.shipments?.map((row, i) => (
                <tr key={i} className="border border-black">
                  <td className="border border-black px-2 py-1 text-center">
                    {i + 1}
                  </td>
                  <td className="border border-black px-2 py-1 text-center">
                    {row?.lrNo}
                  </td>
                  <td className="border border-black px-2 py-1 text-center">
                    {row?.boxes}
                  </td>
                  <td className="border border-black px-2 py-1 text-center">
                    {row?.weight}
                  </td>
                  <td className="border border-black px-2 py-1 text-center">
                    {row?.destination}
                  </td>
                  <td className="border border-black px-2 py-1 text-center">
                    {row?.nextHub}
                  </td>
                </tr>
              ))}

              {/* 🔻 Summary Header */}
              <tr className="bg-gray-200 font-semibold text-center">
                <td colSpan="2" className="border border-black px-2 py-1">
                  Total Consignments
                </td>
                <td colSpan="2" className="border border-black px-2 py-1">
                  Total Packages
                </td>
                <td colSpan="2" className="border border-black px-2 py-1">
                  Total Weight (Kg)
                </td>
              </tr>

              {/* 🔻 Summary Values */}
              <tr className="text-center font-bold">
                <td colSpan="2" className="border border-black px-2 py-1">
                  {manifest?.totalConsignments || 0}
                </td>
                <td colSpan="2" className="border border-black px-2 py-1">
                  {manifest?.totalPackages || 0}
                </td>
                <td colSpan="2" className="border border-black px-2 py-1">
                  {manifest?.totalWeight || 0}
                </td>
              </tr>
            </>
          ) : (
            <tr>
              <td colSpan="6" className="text-center py-4 border border-black">
                No Data
              </td>
            </tr>
          )}
        </tbody>
      </table>
      <div className="mt-5 flex justify-between gap-10">
        {/* <Row label="Driver Name" value={manifest?.driverName} />
        <Row label="Loading Master" value={manifest?.loadingMaster} /> */}
        <div>
          <div className="font-semibold text-gray-700">Loading Master</div>
          <div>{manifest?.loadingMaster || "Rakesh"}</div>
        </div>
        <div>
          <div className="font-semibold text-gray-700">Driver Name</div>
          <div>{manifest?.driverName || "John Doe"}</div>
        </div>
      </div>
      {/* Summary */}
      {/* <div className="mb-4">
        <table className="w-full border border-black border-collapse text-xs">
          <thead>
            <tr className="bg-gray-200">
              <th className="border border-black px-2 py-1">
                Total Consignments
              </th>
              <th className="border border-black px-2 py-1">Total Packages</th>
              <th className="border border-black px-2 py-1">
                Total Weight (Kg)
              </th>
            </tr>
          </thead>
          <tbody>
            <tr className="text-center font-semibold">
              <td className="border border-black px-2 py-1">
                {manifest?.totalConsignments || 0}
              </td>
              <td className="border border-black px-2 py-1">
                {manifest?.totalPackages || 0}
              </td>
              <td className="border border-black px-2 py-1">
                {manifest?.totalWeight || 0}
              </td>
            </tr>
          </tbody>
        </table>
      </div> */}
      {/* Footer Sign */}
      {/* <div className="mt-10 flex justify-between text-sm">
        <div>
          <div className="border-t pt-1 w-40 text-center">Prepared By</div>
        </div>
        <div>
          <div className="border-t pt-1 w-40 text-center">Checked By</div>
        </div>
        <div>
          <div className="border-t pt-1 w-40 text-center">Authorized Sign</div>
        </div>
      </div> */}
    </div>
  );
};

export default ManifestPreview;
